import * as yup from 'yup';

import paymentInterval, { PaymentInterval } from '../../variables/payment-interval';
import validator from '../../utils/validator';
import Plan from '../../view-model/plans/Plan';

const upgradeSchema = yup.object().shape({
    actualPlan: yup
        .number()
        .required('Campo é obrigatório.')
        .test('isValidPlanId', 'Campo inválido.', value => typeof value === 'number'),
    actualInterval: yup
        .string()
        .strict(true)
        .typeError('Campo inválido.')
        .oneOf(paymentInterval.map(option => option.value), 'Campo inválido.'),
    plan: yup
        .mixed()
        .required('Campo é obrigatório.')
        .test('isValidPlan', 'Campo inválido.', value => value && typeof value.id === 'number'),
    interval: yup
        .string()
        .strict(true)
        .typeError('Campo inválido.')
        .required('Campo é obrigatório.')
        .oneOf(paymentInterval.map(option => option.value), 'Campo inválido.')
        .test('notSamePlanAndInterval', 'Para permanecer no mesmo plano, informe a condição de pagamento anual.', (interval, context) =>
            context.parent.actualPlan !== context.parent.plan?.id || (context.parent.actualInterval !== interval && interval === 'yearly')
        )
        .default('yearly'),
    coupon: yup
        .string()
        .strict(true)
        .typeError('Campo inválido.'),
    phone: yup
        .string()
        .strict(true)
        .typeError('Campo inválido.')
        .required('Campo é obrigatório.')
        .test('phone', 'Campo inválido.', value => validator.isValidPhone(value))
        .default('')
});

export type UpgradeValue = yup.TypeOf<typeof upgradeSchema> & {
    plan: Plan,
    interval: PaymentInterval
};

export default upgradeSchema;
